/***************************************************************************************************
** formatDate
 https://moment.github.io/luxon/#/formatting
***************************************************************************************************/

import { DateTime } from "luxon";

const DEFAULT_TIME_ZONE = "local";

const DATE_FORMATS = {
  full_date:    DateTime.DATETIME_FULL_WITH_SECONDS, // LLLL d, yyyy @ h:mm:ss a ZZZZ
  long_date:    DateTime.DATE_HUGE,                  // cccc, LLLL d, yyyy
  date:         DateTime.DATE_MED_WITH_WEEKDAY,      // cccc, LLL d, yyyy
  short_date:   DateTime.DATE_MED,                   // LLL d, yyyy
  time:         DateTime.TIME_SIMPLE,                // h:mm a
  long_time:    DateTime.TIME_WITH_SECONDS,          // h:mm:ss a
};

const defaultOptions = {
  ignoreTimeZone: false,
  formatName: "full_date",
};

export default function formatDate(value, format, opts = {}) {
  if (!value) return null;

  const options = { ...defaultOptions, ...opts };

  const formatName = format || options.formatName;
  const formatString = DATE_FORMATS[formatName];

  let dateTimeObject = DateTime.fromISO(value, { zone: "utc" });

  if (!options.ignoreTimeZone) {
    dateTimeObject = dateTimeObject.setZone(DEFAULT_TIME_ZONE);
  }

  if (formatString) {
    return dateTimeObject.toLocaleString(formatString);
  } else {
    return dateTimeObject.toFormat(format);
  }
}
